class OkResult {
    valueData;
    constructor(value) {
        this.valueData = value;
    }
    value() {
        return this.valueData;
    }
    error() {
        return undefined;
    }
    valueOr(fallback) {
        void fallback;
        return this.valueData;
    }
    errorOr(fallback) {
        return fallback;
    }
    andThen(fn) {
        return fn(this.valueData);
    }
    transform(fn) {
        return ok(fn(this.valueData));
    }
    orElse(fn) {
        void fn;
        return ok(this.valueData);
    }
    transformError(fn) {
        void fn;
        return ok(this.valueData);
    }
}
class ErrResult {
    errorData;
    constructor(error) {
        this.errorData = error;
    }
    value() {
        return undefined;
    }
    error() {
        return this.errorData;
    }
    valueOr(fallback) {
        return fallback;
    }
    errorOr(fallback) {
        void fallback;
        return this.errorData;
    }
    andThen(fn) {
        void fn;
        return err(this.errorData);
    }
    transform(fn) {
        void fn;
        return err(this.errorData);
    }
    orElse(fn) {
        return fn(this.errorData);
    }
    transformError(fn) {
        return err(fn(this.errorData));
    }
}
/**
 * Create one ok Result value.
 */
export function ok(value) {
    return new OkResult(value);
}
/**
 * Create one error Result value.
 */
export function err(error) {
    return new ErrResult(error);
}
//# sourceMappingURL=result.js.map